import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectAnalyticsOfferStatus, selectAnalyticsProduct } from '../../../selectors/analytics';
import {
  selectAddressEditingCountdownMessage,
  selectIsAddressEditingExpired,
  selectMaxAddressEditingDays,
} from '../../../selectors/offer/geo';
import { AddressEditingWarning } from './AddressEditingWarning';
import { Expired, Warning, Countdown } from './components';
import { trackNewOfferLinkClick } from './tracking';

export const AddressEditingWarningContainer = () => {
  const maxAddressEditingDays = useSelector(selectMaxAddressEditingDays);
  const countdownMessage = useSelector(selectAddressEditingCountdownMessage);
  const isAddressEditingExpired = useSelector(selectIsAddressEditingExpired);
  const analyticsOfferStatus = useSelector(selectAnalyticsOfferStatus);
  const analyticsProduct = useSelector(selectAnalyticsProduct);

  const handleNewOfferLinkClick = React.useCallback(() => {
    trackNewOfferLinkClick({ analyticsOfferStatus, analyticsProduct });
  }, [analyticsOfferStatus, analyticsProduct]);

  if (maxAddressEditingDays) {
    return (
      <AddressEditingWarning>
        <Warning maxDays={maxAddressEditingDays} />
      </AddressEditingWarning>
    );
  }

  if (countdownMessage) {
    return (
      <AddressEditingWarning>
        <Countdown message={countdownMessage} />
      </AddressEditingWarning>
    );
  }

  if (isAddressEditingExpired) {
    return (
      <AddressEditingWarning>
        <Expired onLinkClick={handleNewOfferLinkClick} />
      </AddressEditingWarning>
    );
  }

  return null;
};

AddressEditingWarningContainer.displayName = 'AddressEditingWarningContainer';
